import React from 'react'
import { useLocation } from 'react-router-dom'
import { useVision } from './visionContext'
import VisionBlurPlaceholder from './VisionBlurPlaceholder'

/**
 * Story 213, REAPERTURA 4 (C16.10, S336; Judge C16 tanda 2, B-C16-2) — the routes of MIC, as the shell mounts them. A
 * screen that only knew it was protected by Sun's answer (a 423 with no boundary mounted, while the session waits for a
 * camera with the setting NO) is the blurred placeholder in its place: the top bar and the menu stay usable. Uncovering
 * mounts the screen again, which asks for its data again (the guard's remount of S190).
 */
const ProtectedRouteContent = ({ children }) => {
  const { blurredPath } = useVision()
  const location = useLocation()

  if (blurredPath && blurredPath === location.pathname) {
    return (
      <div data-sensitive-route style={{ margin: '8px 0' }}>
        <VisionBlurPlaceholder />
      </div>
    )
  }
  return <>{children}</>
}

export default ProtectedRouteContent
